import { Element, RouterLink } from '@zmedia/bm-soccer-ui/components';
import { memo } from 'react';
import { Avatar } from '@zmedia/bm-soccer-ui/modules/shared/components/avatar';
import { IPlayer } from '@zmedia/bm-soccer-ui/interface';
import { EventPlayer } from '../event';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import styles from './style.module.scss';

interface IProps {
    item: IPlayer;
    style: any;
}
export function PlayerInLineup(props: IProps) {
    const { item, style } = props;
    let color = '#4189EB';
    if (item.point < 6) {
        color = '#DD3333';
    } else if (item.point < 7) {
        color = '#F7B000';
    } else if (item.point < 8) {
        color = '#00B295';
    }

    const { events } = item;
    const name = item.shortName.split(' ');
    return (
        <RouterLink
            className={styles['lineup-player']}
            style={style}
            to={`${URL_SOCCER_PAGE.SUBPATH}${item.path}`}
            title={item.name}
        >
            <Avatar avatar={item.avatar} name={item.name}>
                {item.point > 0 && (
                    <Element
                        className={styles['player-scores']}
                        style={
                            { '--scores-color': color } as React.CSSProperties
                        }
                    >
                        {item.point}
                    </Element>
                )}

                <Element className={styles['player-events']}>
                    <EventPlayer events={events} />
                </Element>
            </Avatar>
            <Element className={styles['lineup-text']}>
                <Element className={styles['shirt']}>
                    {item.shirtNumber}
                </Element>
                {name[name.length - 1]}
            </Element>
        </RouterLink>
    );
}

export default memo(PlayerInLineup);
